import { UseCaseInteractor } from '../../../kernel/use-case'
import { Module } from '../domain/module'
import { ModuleRepository } from '../domain/module.repository'

export const getModulesUseCase: UseCaseInteractor<[moduleRepository: ModuleRepository], [], Module[]> =
  (moduleRepository: ModuleRepository) => async (): Promise<Module[]> => {
    return moduleRepository.getModules()
  }
